module.exports = __webpack_public_path__ + "static/media/logo-green.f698ab86.png";